module.exports = __webpack_public_path__ + "img/52200.d3ca1f98.jpg";